import React, { MutableRefObject, useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
import s from './infinityList.module.scss';
import { InfiniteData } from 'react-query';
import InfiniteScroll from 'react-infinite-scroll-component';
import { LogoLoader } from '@components/UIKit/LogoLoader/LogoLoader';
import { EmptyList } from '@components/UIKit/EmptyList/EmptyList';
import { InfiniteListType } from '@specs/specs';
interface InfinityListProps<T> {
  data: Array<InfiniteData<InfiniteListType<T>> | undefined>;
  children: (props: T, index: number, pageIndex: number) => React.ReactNode;
  hasNextPage: boolean | undefined;
  isFetchingNextPage: boolean;
  fetchNextPage: () => Promise<unknown> | unknown;
  enabledRef: MutableRefObject<boolean> | undefined;
  status: 'error' | 'loading' | 'success';
  EmptyComponent?: () => JSX.Element | null;
  listClassName?: string;
  withFooter?: boolean;
  staticItemBeforeList?: JSX.Element;
  staticItemAfterList?: JSX.Element;
}
export const InfinityMultiList = <T extends Record<'id', number>,>({
  data,
  enabledRef,
  hasNextPage,
  fetchNextPage,
  isFetchingNextPage,
  listClassName,
  status,
  EmptyComponent,
  withFooter = true,
  children,
  staticItemBeforeList,
  staticItemAfterList
}: InfinityListProps<T>) => {
  const {
    ref,
    inView
  } = useInView({
    threshold: 0,
    triggerOnce: true
  });
  const dataLength = data?.flatMap(subArray => subArray?.pages)?.flatMap(page => page?.items)?.length ?? 0;
  useEffect(() => {
    if (!inView || typeof enabledRef === 'undefined') return;
    enabledRef.current = true;
    hasNextPage !== false && dataLength === 0 && fetchNextPage();
  }, [inView, dataLength]);
  useEffect(() => {
    if (document.body.scrollHeight <= document.body.offsetHeight + (withFooter ? 600 : 0) && hasNextPage) {
      fetchNextPage();
    }
  }, [data]);
  if (status === 'success' && !dataLength || status === 'error') return EmptyComponent ? <EmptyComponent /> : <EmptyList />;
  return <div className={s.infinityListWrapper} ref={ref} data-sentry-component="InfinityMultiList" data-sentry-source-file="InfinityMultiList.tsx">
            {status === 'loading' && <LogoLoader />}
            {status === 'success' && <>
                    <InfiniteScroll dataLength={dataLength} next={fetchNextPage} hasMore={!!hasNextPage} loader={<></>} scrollThreshold={0.65} style={{
        overflow: 'visible',
        display: 'flex',
        flexDirection: 'column'
      }}>
                        <div className={listClassName}>
                            {typeof staticItemBeforeList !== 'undefined' && staticItemBeforeList}
                            {data.map(subArray => subArray?.pages?.map((group, index) => group?.items.map((value, index1) => children(value, index1, index))))}
                            {typeof staticItemAfterList !== 'undefined' && staticItemAfterList}
                        </div>
                    </InfiniteScroll>
                    {isFetchingNextPage && <LogoLoader />}
                </>}
        </div>;
};